export default {
  data() {
    return {
      // eslint-disable-next-line
      assetOptions: [
        "General",
        "Report",
        "Fault",
        "Low Risk",
        "Medium Risk",
        "High Risk",
        "Risk Control",
        "Risk Mitigation",
        "Data Quaility"
      ],
      // eslint-disable-next-line
      assetMobility: [
        "Fixed",
        "Mobile"
      ],
      assetType: ["TA1", "TA2", "TA3", "TA4", "TA5", "TA6"],
      assetTypeDescription: [
        {
          type: "TA1",
          title: "Functional Block Unit",
          // eslint-disable-next-line
          des: "Functional Block Unit is major equipment with supporting assets which output delivers final product or service."
        },
        {
          type: "TA2",
          title: "Package Equipment",
          // eslint-disable-next-line
          des: "Packaged equipment (PE) can be operated locally or remotely which could use redundant systems."
        },
        {
          type: "TA3",
          title: "Sub Package Equipment ",
          // eslint-disable-next-line
          des: "Sub Package Equipment is optional and could be part of Packaged Equipment function."
        },
        {
          type: "TA4",
          title: "Primary Asset",
          // eslint-disable-next-line
          des: "Primary Asset has defined primary function, physical object that can be operated, maintained and isolated."
        },
        {
          type: "TA5",
          title: "Secondary Asset",
          // eslint-disable-next-line
          des: "Secondary Asset is maintainable and essential component to achieve functional objective."
        },
        {
          type: "TA6",
          title: "Component Asset",
          // eslint-disable-next-line
          des: "Component Asset is not accessible and not maintainable but could be required for support function."
        }
      ],
      // eslint-disable-next-line
      assetLifecycle: [
        "P1",
        "P2",
        "P3",
        "P4",
        "P5",
        "O1",
        "O2",
        "O3",
        "O4"
      ],
      // eslint-disable-next-line
      assetOperatingMode: [
        "OM1",
        "OM2",
        "OM3",
        "OM4",
        "OM5",
        "OM6"
      ],
      assetFunctionalObjective: [
        "Basic ",
        "Infrastructure",
        "Building",
        "Process Safety",
        "Personal Safety",
        "Production",
        "Utility",
        "Efficiency",
        "Emissions",
        "Environment",
        "Maintenance",
        "Transport",
        "Comfort",
        "Promotion",
        "Entertainment"
      ],
      businessImpactType: [
        "Personal Safety",
        "Process Safety",
        "Equipment Trip",
        "Equipment Damage",
        "Facility Shutdown",
        "System Trip",
        "Maintenance Impact",
        "Regulatory Breach"
      ],
      businessImpactLevel: [
        "Personal Safety",
        "Process Safety",
        "Equipment Trip",
        "Equipment Damage",
        "Facility Shutdown",
        "System Trip",
        "Maintenance Impact",
        "Regulatory Breach"
      ],
      // eslint-disable-next-line
      accessLevel: [
        "Normal",
        "2P",
        "Approval",
        "Restricted",
        "Maint",
        "Safety",
        "No Access"
      ],
      accessType: [
        "AN1",
        "AN2",
        "AN3",
        "AE1",
        "AE1",
        "AE3",
        "AB1",
        "AB2",
        "AB3",
        "AB4",
        "AT1",
        "AT2",
        "AT3",
        "AH1",
        "AH2",
        "AH3",
        "AH4"
      ],
      // eslint-disable-next-line
      assetObjective: [
        "B1",
        "S1",
        "S2",
        "P1",
        "P2",
        "U1",
        "C1",
        "C2",
        "E1",
        "E1",
        "M1"
      ],
      // eslint-disable-next-line
      isolationLevel: [
        "ISO1",
        "ISO2",
        "ISO3",
        "ISO4",
        "ISO5",
        "ISO6"
      ],
      // eslint-disable-next-line
      isolationType: [
        "Electrical",
        "Instrument",
        "Process",
        "EI",
        "IP",
        "EP",
        "EIP"
      ]
    };
  }
};
